<template>
<div>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >

    <el-button
      type="primary"
      icon="el-icon-circle-plus-outline"
      @click="showAddCityDialog(true)"
      style="margin-bottom: 10px"
      >{{$t("title.addArea")}}</el-button
    >
     <div class="tableDiv">
    <el-table :data="cityTable" stripe style="width: 100%" :empty-text="$t('desc.noData')">
      <el-table-column type="index" :label="$t('title.serialNumber')" width="50"> </el-table-column>
      <el-table-column prop="country" :label="$t('title.country')"> </el-table-column>
      <el-table-column prop="province" :label="$t('title.province')"> </el-table-column>
      <el-table-column prop="city" :label="$t('title.city')"> </el-table-column>
      <el-table-column :label="$t('title.operate')" width="90" fixed="right">
        <template slot-scope="scope">
          <template>
            <el-popconfirm
              placement="top"
              :confirmButtonText="$t('button.delete')"
              :cancelButtonText="$t('button.cancel')"
              icon="el-icon-info"
              iconColor="red"
              :title="$t('title.confirmDelete')"
              @confirm="delCity(scope.row)"
            >
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                slot="reference"
              ></el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>
     </div>
  </el-dialog>
  <el-dialog
      :title="$t('title.addArea')"
      :visible.sync="dialogAdd"
      :before-close="cancel"
      width="45%"
      top="5vh"
    >
      <el-form
        ref="addRef"
        :rules="rules"
        :model="Cityform"
        label-width="200px"
      >
        <el-form-item prop="city" :label="$t('title.city')">
          <el-cascader
                  :placeholder="$t('desc.select')"
            v-model="Cityform.city"
            :props="{ checkStrictly: true }"
            :options="optionRegion"
            style="width: 200px"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="success" :loading="loading" @click="onSubBtn('addRef')">{{$t("button.confirm")}}</el-button>
          <el-button @click="cancel">{{$t("button.cancel")}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
</template>

<script>
export default {
  name: "index",
  props: {
    loading:false,
    title: "",
    dialogAddClient: false,
    dialogAdd: false,
    Cityform: {
      city: {
        type: Array,
        default: function () {
          return [];
        },
      },
      officeId:""
    },
    optionRegion: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cityTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {

      rules: {
        city: [
          { required: true, message: this.$t("tips.needed"), trigger: ["blur", "change"] },
        ],
      },
    };
  },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
    },
    cancel() {
      this.showAddCityDialog(false);
    },
    //子页面
    showAddCityDialog(visible) {
      this.$emit("showAddCityDialog", visible);
      if (visible) {
        //打开窗口前重置验证
        if (this.$refs.addRef != undefined) {
          this.$refs.addRef.resetFields();
        }
      }
    },
    //父页面
    delCity(index, row, tableType) {
      this.$emit("delCity", index, row, tableType);
    },
  },
};
</script>

<style>
</style>
